// @flow
import * as pwaIconApi from "./pwaIconApi";

export default pwaIconApi;
